import type {
  FormulaState,
  RootState,
  GraphVariableOrFormula,
  Formula,
} from "@/types";
import type { GetterTree } from "vuex";

export const getters: GetterTree<FormulaState, RootState> = {
  // VARIABLES
  getVariablesData(state): GraphVariableOrFormula[] {
    return state.variables.data;
  },
  getVariablesCount(state): number {
    return state.variables.count;
  },
  getVariablesLoading(state): boolean {
    return state.variables.loading;
  },
  getVariablesError(state): string | null {
    return state.variables.error;
  },

  // CurrentFormula

  getCurrentFormula(state): any {
    return state.currentFormula.data;
  },
  getCurrentFormulaState(state): boolean {
    return state.currentFormula.valid;
  },
  getCurrentFormulaResult(state): number | null {
    return state.currentFormula.result;
  },
  getCurrentFormulaError(state): string | null {
    return state.currentFormula.error;
  },
  getCurrentFormulaLoading(state): boolean {
    return state.currentFormula.loading;
  },

  // NEW FORMULA
  getFormula(state): Formula {
    return state.formula.data;
  },
  getFormulaLoading(state): boolean {
    return state.formula.loading;
  },

  // TO EDIT FORMULA
  getToEditFormula(state): Formula {
    return state.toEditFormula.data;
  },
  getToEditFormulaLoading(state): boolean {
    return state.toEditFormula.loading;
  },
  getFormulaError(state): string | null {
    return state.formula.error;
  },
};
